<template>
<div class="form-group bmd-form-group textarea-float" :class='{"is-filled": !!modelValue, "is-focused": focused}'>
  <label class="bmd-label-floating">{{title}}</label>
  <textarea class="form-control"
    :name="name"
    :id="id"
    :required="required"
    :value="modelValue"
    @input="handleChange"
    @focus="focused= true"
    @blur="focused = false"
    @invalid="handleInvalid"
    :rows="rows" />
</div>
</template>

<script>
export default
{
  name: "TextareaFloat",
  props:
  {
    rows:
    {
      type: Number,
      default: 4
    },
    required:
    {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: "title"
    },
    name: {
      type: String,
      default: ''
    },
    id: {
      type: String,
      default: ''
    },
    modelValue: String,
  },
  data() {
    return {
      focused: false
    }
  },
  methods:
  {
    handleChange( e )
    {
      this.$emit( "valid", this.valid )
      this.$emit( "update:modelValue", e.target.value )
    },
    handleInvalid(e){
      e.preventDefault();
    }
  }
}
</script>
